import ApolloClient from 'apollo-boost';
import * as Sentry from '@sentry/browser';
import { useAuth0 } from './react-auth0-spa';
import { handleApolloError, isAuthError } from './apolloClientErrors';

export async function getAuthHeaders(getTokenSilently, logout) {
  try {
    const token = await getTokenSilently();
    return { Authorization: `Bearer ${token}` };
  } catch (error) {
    if (error.error === 'login_required' || isAuthError(error.message)) {
      logout({ returnTo: import.meta.env.VITE_HOME_URL });
      return null;
    }
    throw error;
  }
}

function useApolloClient(getTokenSilently) {
  const { logout } = useAuth0();

  return new ApolloClient({
    uri: import.meta.env.VITE_GRAPHQL_SERVER,
    request: async (operation) => {
      const headers = await getAuthHeaders(getTokenSilently, logout);
      if (!headers) return;

      operation.setContext({ headers });
    },
    onError: ({ graphQLErrors, networkError, response }) => {
      handleApolloError({
        graphQLErrors,
        networkError,
        response,
        logout,
        captureException: Sentry.captureException,
        captureMessage: Sentry.captureMessage,
      });
    },
  });
}

export default useApolloClient;
